<template>
  <div class="wine-making-notes">
    <div class="grid">
      <div
        v-for="(item, index) in computedObj"
        :key="index"
        class="grid-item"
      >
        <div class="wine-making-note">
          <div class="label">
            {{ item.title }}
          </div>
          <div class="value">
            <read-more
              v-if="item.text"
              :text="item.text"
              :max-chars="180"
              class="item-description"
            />
          </div>
        </div>
      </div>
    </div>
    <template v-if="hasLimit">
      <div class="show-more">
        <HighlightButton
          button-type="rounded"
          button-style="outline"
          button-size="small"
          title="Show More"
          @click.native="showMore()"
        />
      </div>
    </template>
  </div>
</template>

<script>
import ReadMore from '../../ReadMore.vue'

export default {
  name: 'wine-making-notes',
  components: {
    ReadMore
  },
  props: {
    content: {
      type: Array,
      required: true
    },
    map: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      limit: 3
    }
  },
  computed: {
    displayItems() {
      const items = []
      const notes = this.$store.getters['products/getMap']('variable')[this.map]
      for (const item of this.content) {
        items.push({ ...item, title: notes[item.title] ?? item.title[0].toUpperCase() + item.title.slice(1) })
      }
      return items
    },
    hasLimit() {
      return this.limit != null && this.content.length > this.limit
    },
    computedObj() {
      return this.limit ? this.displayItems.slice(0, this.limit) : this.displayItems
    }
  },
  methods: {
    showMore() {
      return this.limit = null
    }
  }

}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

//core grid stucture
.grid {
  --col-size: 1;

  @include media-breakpoint-up(lg) {
    --col-size: 3;
  }
}

.grid {
  grid-template-columns: repeat(var(--col-size), 1fr);
  display: grid;
  gap: 1.5em;
  row-gap: 1.5em;

  .grid-item {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
  }
}

//inline readmore on item
.item-description {
 ::v-deep p {
    &:last-of-type {
      display: inline;
      margin-bottom: 0;
    }
  }
}

.label {
  font-weight: 600;
  font-family: var(--vc-heading-font);
  margin-bottom: .5em;
  font-size: 1.1em;
}

//show more position
.show-more {
  margin-top: 1.5em;
  display: flex;
  justify-content: center;
}

//styling specific to the item content
.wine-note-item {
  height: 100%;
}

</style>>
